import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M7.00009 1.86987C7.00009 1.86987 1.10011 11.6299 3.14011 26.6099C5.06011 40.6699 8.59008 42.0499 4.05008 49.0799C-0.179919 55.6399 -0.719934 63.6099 7.91007 72.6899C7.91007 72.6899 5.80007 69.6399 11.5401 65.4299C18.3501 60.4399 24.4801 56.5799 23.8001 47.2699C23.1101 37.8099 15.1601 34.9799 16.9901 21.6199C18.5801 10.0399 14.7701 4.57986 14.7701 4.57986L7.00009 1.86987Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.95219 23.729C3.19122 25.227 3.55629 26.6911 4.00309 28.11L4.00309 28.11L4.00389 28.1126C4.94981 31.0622 6.35033 33.7894 8.00422 36.412C8.41585 37.097 8.84296 37.7696 9.26993 38.4419C10.5144 40.4016 11.7576 42.3592 12.6124 44.6169L12.6125 44.6171C13.1606 46.0629 13.4802 47.6108 13.4071 49.1374C13.2545 47.6005 12.7387 46.1691 12.1012 44.8344L12.1013 44.8344L12.0979 44.8276C11.4188 43.4592 10.5975 42.1535 9.74337 40.8616C9.47853 40.4611 9.21141 40.0631 8.94412 39.6648C8.34404 38.7708 7.74311 37.8755 7.16533 36.947C6.34568 35.6137 5.58698 34.2142 4.93757 32.7683C4.30904 31.3143 3.80064 29.8067 3.46882 28.2647L3.46875 28.2644C3.14561 26.7675 2.95559 25.2382 2.95219 23.729Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M66.5001 1.41992C66.5001 1.41992 72.4001 11.1799 70.3601 26.1599C68.4401 40.2199 64.9101 41.5999 69.4501 48.6299C73.6801 55.1899 74.2201 63.1599 65.5901 72.2399C65.5901 72.2399 67.7001 69.1899 61.9601 64.9799C55.1501 59.99 49.0202 56.1299 49.7002 46.8199C50.3902 37.3599 58.3402 34.5299 56.5102 21.1699C54.9202 9.58992 58.7301 4.12994 58.7301 4.12994L66.5001 1.41992Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M61.4122 44.3576L61.4122 44.3576L61.4089 44.3644C60.7736 45.6946 60.2476 47.1344 60.1029 48.6626C60.0308 47.1465 60.3503 45.5911 60.8977 44.1471L60.8981 44.1461C61.7549 41.8711 63.0154 39.8897 64.2775 37.9057C64.6913 37.2553 65.1052 36.6046 65.5052 35.9432C67.1705 33.3185 68.5606 30.5813 69.5061 27.6431L69.5061 27.6431L69.5074 27.639C69.9492 26.2253 70.3117 24.764 70.5493 23.2675C70.5476 24.778 70.36 26.3062 70.0413 27.7949C69.709 29.339 69.2102 30.8463 68.5732 32.297C67.9235 33.7437 67.1645 35.1438 66.3444 36.4777C65.7563 37.4285 65.1409 38.3452 64.526 39.2612C64.2735 39.6373 64.0211 40.0132 63.7707 40.3914C62.9155 41.6829 62.0915 42.9889 61.4122 44.3576Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
